import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full space-x-2 flex justify-end" }

import { computed } from 'vue';

import { useCarBrandsStore } from '@/stores/dictionary/car-brands';
import { useModalsStore } from '@/stores/modals';
import { useI18n } from 'vue-i18n';
import { CarBrandResource } from '@shared/resources/car-brand';

import PageWrapper from '@components/page-wrapper/PageWrapper.vue';
import { Table, TableClientDataManager, TableComponentParams } from '@ui-kit/table';
import Button from '@ui-kit/controls/button/Button.vue';
import ModalConfirmation from '@components/modals/ModalConfirmation.vue';
import ModalManageCarBrand from './modals/ModalManageCarBrand.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PageCarBrands',
  setup(__props) {

const carBrandsStore = useCarBrandsStore();
const modalsStore = useModalsStore();
const { t } = useI18n();

const tableManager = new TableClientDataManager({
  providedData: computed(() => carBrandsStore.data),
  searchBy: ['name'],
  loading: computed(() => carBrandsStore.isLoad),
});
const tableParams = computed<TableComponentParams<CarBrandResource>>(() => {
  return {
    columns: [
      {
        name: 'name',
        data: 'name',
        title: t('fields.name'),
        sortable: true,
      },
      {
        name: 'country',
        data: 'country',
        title: t('fields.country'),
        sortable: true,
      },
      {
        name: 'actions',
        title: '',
        width: 200,
      },
    ],
  };
});

function manageCarBrand(brand?: CarBrandResource) {
  modalsStore.addModal({
    component: ModalManageCarBrand,
    props: {
      data: brand,
    },
  });
}
function removeCarBrand(brand: CarBrandResource) {
  modalsStore.addModal({
    component: ModalConfirmation,
    props: {
      title: t('pages.car-brands.remove-label'),
      danger: true,
      confirmText: t('common.actions.delete'),
      confirm: () => {
        return carBrandsStore.remove(brand.id);
      }
    }
  });
}

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createBlock(PageWrapper, {
    title: _ctx.$t('navigation.car_brands')
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Table), {
        "data-manager": _unref(tableManager),
        params: _unref(tableParams)
      }, {
        "header-right": _withCtx(() => [
          _createVNode(Button, {
            size: "xl",
            "button-type": "outline",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (manageCarBrand()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_FontAwesomeIcon, {
                icon: "plus",
                class: "mr-2"
              }),
              _createTextVNode(_toDisplayString(_ctx.$t('common.actions.create_new')), 1)
            ]),
            _: 1
          })
        ]),
        "cell-actions": _withCtx(({ row }) => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(Button, {
              size: "sm",
              onClick: ($event: any) => (manageCarBrand(row))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_FontAwesomeIcon, {
                  icon: "pen",
                  class: "mr-2"
                }),
                _createTextVNode(_toDisplayString(_ctx.$t('common.actions.edit')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(Button, {
              size: "sm",
              color: "danger",
              onClick: ($event: any) => (removeCarBrand(row))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_FontAwesomeIcon, { icon: "trash" })
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["data-manager", "params"])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})